import React, { useEffect, useRef } from "react";
import { AlertTriangle, Check, Info, X } from "lucide-react";

import "../notifications/vexa-dialog.css";

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmText = "Aceptar",
  cancelText = "Cancelar",
  onConfirm,
  onCancel,
  type = "info",
  loading = false,
  closeOnOverlay = true
}) {
  const confirmButtonRef = useRef(null);
  const isDanger = type === "danger";
  const Icon = isDanger || type === "warning" ? AlertTriangle : Info;

  useEffect(() => {
    if (!open) return undefined;

    confirmButtonRef.current?.focus();

    const handleKeyDown = event => {
      if (event.key === "Escape" && !loading) {
        onCancel?.();
      }

      if (event.key === "Enter" && !loading) {
        if (event.target?.closest?.(".vexa-dialog__button--quiet")) {
          onCancel?.();
        } else {
          onConfirm?.();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, loading, onCancel, onConfirm]);

  if (!open) return null;

  return (
    <div
      className="vexa-dialog-backdrop"
      onMouseDown={event => {
        if (closeOnOverlay && event.target === event.currentTarget && !loading) {
          onCancel?.();
        }
      }}
    >
      <section
        aria-labelledby="vexa-confirm-title"
        aria-modal="true"
        className={`vexa-dialog vexa-dialog--${type}`}
        role="alertdialog"
      >
        <button
          aria-label="Cerrar diálogo"
          className="vexa-dialog__close"
          disabled={loading}
          onClick={onCancel}
          type="button"
        >
          <X size={18} />
        </button>

        <div className="vexa-dialog__icon"><Icon size={23} strokeWidth={2.1} /></div>

        <div className="vexa-dialog__content">
          <p className="vexa-dialog__eyebrow">VexaDent</p>
          <h2 id="vexa-confirm-title">{title}</h2>
          <p className="vexa-dialog__message">{message}</p>

          <div className="vexa-dialog__actions">
            <button
              className="vexa-dialog__button vexa-dialog__button--quiet"
              disabled={loading}
              onClick={onCancel}
              type="button"
            >
              {cancelText}
            </button>
            <button
              className={`vexa-dialog__button vexa-dialog__button--${type}`}
              disabled={loading}
              onClick={onConfirm}
              ref={confirmButtonRef}
              type="button"
            >
              <Check size={16} />
              {loading ? "Procesando…" : confirmText}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
